export default __webpack_public_path__ + "static/media/Shopify_Challenge.062470b5.png";